import { SectionLayout } from "layouts";
import Link from "next/link";
import { Trans } from "react-i18next";
import { IPublication, PublicationItem } from "./PublicationItem";
import publications from "./publications.yml";

const Publications: React.FC = () => {
  return (
    <SectionLayout
      separatorProps={{
        variant: "offset",
      }}
      className="bg-grey"
      heading={
        <Trans i18nKey="mhealth.publications.heading">
          Mhealth <strong>publications</strong>
        </Trans>
      }
      subheading={
        <Trans i18nKey="mhealth.publications.subheading">
          <a href="#" className="underline uppercase text-blue">
            See more research
          </a>
        </Trans>
      }
    >
      <div className="max-w-[1200px] mx-auto">
        <div className="grid gap-8 md:grid-cols-2">
          {publications.map((publication: IPublication, index: number) => (
            <PublicationItem
              key={`publication-item-${index}`}
              {...publication}
            />
          ))}
        </div>
        <div className="text-[20px] grid mx-auto gap-4 max-w-fit mt-8 font-light ">
          <div className="mx-auto text-[#323E47]">
            <Trans i18nKey="mhealth.publications.footer.faqs">
              View the mHealth FAQs
              <a className="text-[#04A9F4] font-semibold" href={"/support"}>
                here
              </a>
            </Trans>
          </div>
        </div>
      </div>
    </SectionLayout>
  );
};
export default Publications;
